import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import emailjs from '@emailjs/browser';
import { INTEGRATIONS, initAllIntegrations } from '@/config/integrations';

// Initialize EmailJS
emailjs.init(INTEGRATIONS.EMAIL.EMAILJS.PUBLIC_KEY);

// Initialize all integrations
initAllIntegrations();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
